import { render, staticRenderFns } from "./DialectSection.vue?vue&type=template&id=44bb8dad&scoped=true&"
import script from "./DialectSection.vue?vue&type=script&lang=js&"
export * from "./DialectSection.vue?vue&type=script&lang=js&"
import style0 from "./DialectSection.vue?vue&type=style&index=0&id=44bb8dad&prod&lang=css&"
import style1 from "./DialectSection.vue?vue&type=style&index=1&id=44bb8dad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb8dad",
  null
  
)

export default component.exports